<template>
	<div class="order-body">
		<Search :ids="ids" :rpasId="rpasId" :AuthorityList='AuthorityList' ref='searchRef' @modifySuc="modifySuc" @handleSearch="handleSearch" @exportExcel="exportExcel"/>
		<MainTable
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:sumProductQuantity='sumProductQuantity'
			:sumTotalMoney='sumTotalMoney'
			:AuthorityList='AuthorityList'
			@modifySuc="modifySuc"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
		/>
	</div>
</template>

<script>
import Search from '@/components/storage/Search.vue'
import MainTable from '@/components/storage/MainTable.vue'
export default {
	name: 'storage',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'13_0001_0001_00': false,
				'13_0001_0002_00': false,
				'13_0001_0003_00': false
			},
			dateValue: [],
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			searchCode: '',
			searchName: '',
			stockType: -1,
			stockTypeName: '',
			hasDocument: -1,
			memo: '',
			theOtherName: '',
			searchDateType: 2,
			sumProductQuantity: 0,
			sumTotalMoney: '0.00',
			excelParams: {
				hasDocument: -1,
				memo: '',
				searchCode: '',
				searchDateType: 2,
				searchName: '',
				stockType: -1,
				stockTypeName: '',
				theOtherName: ''
			},
			ids: [],
			checkid: '',
			rpasId: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$store.dispatch('requestPost', {
				url: `${vm.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				if (res.actualtimeinventoryflag === 1) {
					vm.$router.push('error')
				} else {
					next()
				}
			}).catch(err => {
				this.$message.error(err.msg)
				vm.$router.push('error')
			})
		})
	},
	created () {
		if (this.$route.params.id) {
			this.checkid = this.$route.params.id
			this.rpasId = [this.$route.params.id]
		}
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.$fxEventBus.$emit('setMenu', '14-1')
		this.getAuthority('13_0001_0000_00')
		this.openPage()
	},
	methods: {
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				searchCode: this.searchCode,
				searchDateType: this.searchDateType,
				searchName: this.searchName,
				theOtherName: this.theOtherName,
				stockType: this.stockType,
				stockTypeName: this.stockTypeName,
				hasDocument: this.hasDocument,
				memo: this.memo,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('storageSelect', JSON.stringify(params))
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('storageSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('storageSelect'))
				this.dateValue = data.dateValue
				this.searchCode = data.searchCode
				this.searchDateType = data.searchDateType
				this.searchName = data.searchName
				this.theOtherName = data.theOtherName
				this.stockType = data.stockType
				this.stockTypeName = data.stockTypeName
				this.hasDocument = data.hasDocument
				this.memo = data.memo
				this.page = data.page
				this.size = data.size
				this.excelParams = {
					searchCode: data.searchCode,
					searchName: data.searchName,
					stockType: data.stockType,
					stockTypeName: data.stockTypeName,
					hasDocument: data.hasDocument,
					memo: data.memo,
					theOtherName: data.theOtherName,
					searchDateType: data.searchDateType
				}
				if (this.searchDateType === 5) {
					this.excelParams.searcheStartDate = data.dateValue[0]
					this.excelParams.searchEndDate = data.dateValue[1]
				}
			}
			this.findOrderList()
		},
		modifySuc () {
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.dateValue = data.dateValue
			this.searchCode = data.searchCode
			this.searchDateType = data.searchDateType
			this.searchName = data.searchName
			this.theOtherName = data.theOtherName
			this.stockType = data.stockType
			this.stockTypeName = data.stockTypeName
			this.hasDocument = data.hasDocument
			this.memo = data.memo
			this.page = 1
			this.excelParams = {
				searchCode: data.searchCode,
				searchName: data.searchName,
				stockType: data.stockType,
				stockTypeName: data.stockTypeName,
				hasDocument: data.hasDocument,
				memo: data.memo,
				theOtherName: data.theOtherName,
				searchDateType: data.searchDateType
			}
			if (this.searchDateType === 5) {
				this.excelParams.searcheStartDate = data.dateValue[0]
				this.excelParams.searchEndDate = data.dateValue[1]
			}
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		// 导出
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/stock/list/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(this.excelParams))
		},
		download (blobUrl, num) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			var sec = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
			let name = '中心库存导出(' + year + month + day + hour + min + sec + ').xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		findOrderList () {
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				searchCode: this.searchCode,
				searchName: this.searchName,
				stockType: this.stockType,
				stockTypeName: this.stockTypeName,
				hasDocument: this.hasDocument,
				memo: this.memo,
				theOtherName: this.theOtherName,
				searchDateType: this.searchDateType
			}
			if (this.searchDateType === 5) {
				params.searcheStartDate = this.dateValue[0]
				params.searchEndDate = this.dateValue[1]
			}
			if (this.checkid) {
				params.productAttrplanId = this.checkid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/list`,
				data: params
			}).then(res => {
				this.totalCount = res.data.count
				if (res.data.list.stockList !== null) {
					res.data.list.stockList.forEach(e => {
						e.docVisible = false
						e.productPrice = this.$fxUtils.toFixedSHW(e.productPrice, 2)
						e.totalMoney = this.$fxUtils.toFixedSHW(e.totalMoney, 2)
						if (e.stockDocumentCount === 1 && e.fileName.length > 10) {
							e.fileName = e.fileName.substring(0, 10) + '...' + e.fileName.split('.')[e.fileName.split('.').length - 1]
						}
					})
					this.tableData = res.data.list.stockList
					// this.sumInventory = res.data.list.sumInventory
					this.sumProductQuantity = res.data.list.sumProductQuantity
					this.sumTotalMoney = this.$fxUtils.toFixedSHW(res.data.list.sumTotalMoney, 2)
					if (!this.$route.params.id) {
						this.rpasId = Array.from(new Set(this.tableData.map(item => { return item.productAttrplanId })))
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.menu-box {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:50px;
		line-height: 50px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 50px
			padding-right 20px
			i {
				border-radius 50%
				border 1px solid #2c3e50
				cursor pointer
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
		}
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
